export default __webpack_public_path__ + "static/media/picTuanPhan.6877e650.png";